import React, { PureComponent } from 'react'
import {
  bool, string, func, shape, arrayOf,
} from 'prop-types'
import find from 'lodash/find'
import noop from 'lodash/noop'
import pick from 'lodash/pick'
import prop from 'lodash/fp/prop'
import { withI18n } from '@active/react-utils/i18n'
import DefaultComponentLayout, { LayoutContent } from '../../../common/Layout'
import { FacebookCreateAccount, FacebookBindAccount } from '../../../common/Facebook'
import CoppaEmailInput from '../../../common/CoppaEmailInput'
import withKeycloak from '../../../../shared/utils/withKeycloak'
import SigninWithContent from './SigninWithContent'
import PasswordUpdater from '../PasswordUpdater'
import ReagreeWaiver from '../ReagreeWaiver'
import ReagreeWaiverConfirm from '../ReagreeWaiverConfirm'
import GrantPermission from '../GrantPermission'
import CountryChoose from '../CountryChoose'
import Verification from '../Verification'
import PhoneAuthentication from '../PhoneAuthentication'
import LinkAccount from '../LinkAccount'
import ReviewProfileModal from '../ReviewProfileModal'
import './injectSigninWithContent.scss'

const STATUS = {
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  PSW_NOT_QUALFIED: 'PSW_NOT_QUALFIED',
  NO_COUNTRY_CODE: 'NO_COUNTRY_CODE',
  WAIVER_EXPIRED: 'WAIVER_EXPIRED',
  PERMISSION_FAIL: 'PERMISSION_FAIL',
  COPPA: 'COPPA',
  NEED_PERMISSION: 'NEED_PERMISSION',
  OTP_INITED: 'OTP_INITED', // TODO: Remove MFAV1
  PHONE_SETUP_INITED: 'PHONE_SETUP_INITED',
  IDP_LOGIN_INITED: 'IDP_LOGIN_INITED',
  REVIEW_PROFILE_INITED: 'REVIEW_PROFILE_INITED',
}

const injectSigninWithContent = WrappedComponent => {
  class WrapperComponent extends PureComponent {
    static propTypes = {
      Header: func,
      FacebookBtn: shape({}).isRequired,
      configureTrack: func.isRequired,
      processes: shape({
        signIn: func.isRequired,
      }).isRequired,
      actions: shape({
        signinSuccessCallback: func.isRequired,
        newAccountCallback: func.isRequired,
      }).isRequired,
      clientConfig: shape({
        signinOptions: arrayOf(shape({})),
      }).isRequired,
      authWithKeycloak: bool,
      onKeycloakSubmit: func,
      initKeycloak: func,
      keycloak: shape({}),
      higherPiorityRedirectUrl: string,
      handleSocialClick: func,
      locale: string,
    }

    static defaultProps = {
      Header: null,
      authWithKeycloak: false,
      onKeycloakSubmit: null,
      initKeycloak: noop,
      keycloak: null,
      higherPiorityRedirectUrl: '',
      handleSocialClick: noop,
      locale: 'en_US',
    }

    closeModals = {
      errorMsg: null,
      isReviewProfileShow: false,
      isLinkAccountShow: false,
      isPasswordUpdaterShow: false,
      isCountryChooseShow: false,
      isGrantPermissionShow: false,
      isReagreeWaiverShow: false,
      isReagreeWaiverConfirmShow: false,
      isVerificationShow: false, // TODO: Remove MFAV1
      isPhoneAuthenticationShow: false,
    }

    constructor(props) {
      super(props)
      this.state = {
        coppaEmailResult: {},
        passwordUpdaterResult: {
          code: null,
          message: null,
        },
        openReagreeWaiverFrom: '',
        isReagreeWaiverShow: false,
        isReagreeWaiverConfirmShow: false,
        isReviewProfileShow: false,
        isLinkAccountShow: false,
        isPasswordUpdaterShow: false,
        isCountryChooseShow: false,
        isGrantPermissionShow: false,
        isVerificationShow: false,
        isPhoneAuthenticationShow: false,
        isBack: false,
        resetAgrees: false,
        clientName: '',
        errorMsg: null,
        accountCountryCode: '',
        nextTimeWindow: '',
        senderPhone: '',
        epid: '',
        channel: '',
        identityProviderAlias: '', // for LinkAccount
        identityProviderUsername: '', // for LinkAccount
        idpValues: {}, // for ReviewProfile
        emailField: {}, // for ReviewProfile
        signedWaiverIds: [],
      }
    }

    componentDidMount() {
      const { initKeycloak } = this.props
      initKeycloak(this.onKeycloakSubmitSuccess)
    }

    componentWillUnmount() {
      if (this.reagreeWaiverConfirmTimer) {
        clearTimeout(this.reagreeWaiverConfirmTimer)
      }
      if (this.reagreeWaiverTimer) {
        clearTimeout(this.reagreeWaiverTimer)
      }
      if (this.linkAccountTimer) {
        clearTimeout(this.linkAccountTimer)
      }
    }

    setSwitchConfig = newState => {
      this.setState({
        facebookCreateAccountConfig: null,
        facebookBindAccountConfig: null,
        ...newState,
      })
    }

    updateState = values => {
      this.setState({ ...values })
    }

    handleVerificationClose = () => {
      this.setState({
        isVerificationShow: false,
      })
      const { initKeycloak } = this.props
      initKeycloak(this.onKeycloakSubmitSuccess)
    }

    handleVerificationRequestCode = values => {
      this.handleKeycloakSubmit(values, false)
    }

    handleVerificationVerify = values => {
      this.handleKeycloakSubmit(values, false)
    }

    handleReagreeWaiverNewAccountSubmit = () => {
      const { newAccount, openReagreeWaiverFrom, signedWaiverIds } = this.state
      this.setState({
        isReagreeWaiverShow: false,
        isReagreeWaiverConfirmShow: false,
      })
      if (openReagreeWaiverFrom === 'newAccountModel') { // cuiSignin new account model
        const { actions: { newAccountCallback } } = this.props
        newAccountCallback({
          email: newAccount,
          signedWaiverIds,
          reagree: true,
        })
      } else { // idp model
        this.handleKeycloakSubmit({ signedWaiverIds, reagree: true })
      }
    }

    handleReagreeWaiverClose = () => {
      this.setState({
        isReagreeWaiverShow: false,
      }, () => {
        this.reagreeWaiverConfirmTimer = setTimeout(() => {
          this.setState({
            isReagreeWaiverConfirmShow: true,
          })
        }, 500)
      })
    }

    handleReagreeWaiverCheckboxChange = signedWaiverIds => {
      this.setState({
        resetAgrees: false,
        signedWaiverIds,
      })
    }

    handleReagreeWaiverConfirmClose = () => {
      this.setState({
        resetAgrees: true,
        isReagreeWaiverConfirmShow: false,
      })
      const { initKeycloak } = this.props
      initKeycloak(this.onKeycloakSubmitSuccess)
    }

    handleReagreeWaiverConfirmCancel = () => {
      this.setState({
        isReagreeWaiverConfirmShow: false,
      }, () => {
        this.reagreeWaiverTimer = setTimeout(() => {
          this.setState({
            isReagreeWaiverShow: true,
          })
        }, 500)
      })
    }

    handlePasswordUpdaterModalClose = () => {
      this.setState({
        isPasswordUpdaterShow: false,
        passwordUpdaterResult: {},
      })
      const { initKeycloak } = this.props
      initKeycloak(this.onKeycloakSubmitSuccess)
    }

    handlePasswordUpdaterSubmit = ({ newPswd }) => {
      this.setState({
        isPasswordUpdaterShow: false,
      })
      this.handleKeycloakSubmit({
        newPswd,
      })
    }

    handleChangeCountry = value => {
      this.setState({
        selectedCountryCode: value,
      })
    }

    handleCountryChooseModalClose = () => {
      this.setState({
        isCountryChooseShow: false,
      })
      const { initKeycloak } = this.props
      initKeycloak(this.onKeycloakSubmitSuccess)
    }

    handleCountryChooseSubmit = () => {
      const { selectedCountryCode } = this.state
      this.setState({
        isCountryChooseShow: false,
      })
      this.handleKeycloakSubmit({
        selectedCountryCode,
        isCountryChooseSubmit: true,
      })
    }

    handleReagreeWaiverBack = () => {
      this.setState({
        isReagreeWaiverShow: false,
      }, () => {
        setTimeout(() => {
          this.setState({
            isCountryChooseShow: true,
          })
        }, 500)
      })
    }

    handleGrantPermissionClose = () => {
      this.setState({
        isGrantPermissionShow: false,
      })
    }

    handleGrantPermissionSubmit = () => {
      this.handleKeycloakSubmit({
        'permissions[]': 'PROFILE',
      })
    }

    handleReviewProfileSubmit = values => {
      this.handleKeycloakSubmit(values, false)
    }

    cleanState = () => {
      this.setState({
        kcMessageType: '',
        kcErrorMessage: '',
      })
    }

    handleReviewProfileModalClose = () => {
      this.setState({
        isReviewProfileShow: false,
      })
      const { initKeycloak } = this.props
      initKeycloak(this.onKeycloakSubmitSuccess)
    }

    handleLinkAcountSigninToLink = values => {
      this.handleKeycloakSubmit(values, false)
    }

    handleLinkAccountClose = () => {
      this.setState({
        isLinkAccountShow: false,
      })
      const { initKeycloak } = this.props
      initKeycloak(this.onKeycloakSubmitSuccess)
    }

    onKeycloakSubmitSuccess = values => ({ // eslint-disable-line
      status,
      identityProviderAlias, // for LinkAccount
      idpData: idpValues, // For idp review profile and idp signin
      emailField, // for ReviewProfile
      pendingKey,
      clientName,
      accountCountryCode,
      code, // error code during update password
      message,
      authorizationCode,
      keycloakRedirectUri, // For application call token API
      loginURL,
      kcMessageType, kcErrorMessage, // For keycloak message
      ...rest
    }) => {
      const {
        authWithKeycloak,
        configureTrack,
        actions: {
          signinSuccessCallback,
        },
        higherPiorityRedirectUrl,
        keycloak,
      } = this.props
      let nextState = {}

      if (status === STATUS.SUCCESS) {
        configureTrack({
          eventName: 'CUISignInConfirmation',
          widget: 'CUISignin',
          pageType: 'cui sign in',
          explicitName: 'cui sign in confirmation',
          eventTracking: 'active connect',
        })
        if (signinSuccessCallback) {
          signinSuccessCallback(authorizationCode ? { authorizationCode, keycloak, keycloakRedirectUri } : {
            email: values.accountname, loginURL, pendingKey, accountCountryCode, clientName, ...rest,
          })
        } else {
          window.location.href = higherPiorityRedirectUrl || loginURL
        }
      } else if (status === STATUS.REVIEW_PROFILE_INITED) {
        nextState = {
          isReviewProfileShow: true,
          idpValues,
          emailField,
          kcMessageType,
          kcErrorMessage,
        }
      } else if (status === STATUS.IDP_LOGIN_INITED) {
        nextState = {
          isLinkAccountShow: true,
          identityProviderAlias,
          idpValues,
          kcMessageType,
          kcErrorMessage,
        }
      } else if (status === STATUS.OTP_INITED) {
        nextState = {
          isVerificationShow: true,
          nextTimeWindow: prop('nextTimeWindow')(rest),
          senderPhone: prop('senderPhone')(rest),
          epid: prop('epid')(rest),
          channel: prop('channel')(rest),
          errorMsg: message,
        }
      } else if (status === STATUS.PHONE_SETUP_INITED) {
        nextState = {
          isPhoneAuthenticationShow: true,
        }
      } else if (status === STATUS.COPPA) {
        nextState = {
          coppaEmailResult: {
            showCoppaEmailInput: true,
            pendingKey,
          },
        }
      } else if (status === STATUS.NEED_PERMISSION) {
        nextState = {
          isGrantPermissionShow: true,
          clientName,
        }
      } else if (status === STATUS.PERMISSION_FAIL) {
        nextState = {
          errorMsg: 'passport.permission.granting.fail',
          showError: true,
        }
        configureTrack({
          eventName: 'CUISignInError',
          widget: 'CUISignin',
          pageType: 'cui sign in',
          explicitName: 'cui sign in error PERMISSION_FAIL',
        })
      } else if (status === STATUS.WAIVER_EXPIRED) {
        nextState = {
          resetAgrees: true,
          isReagreeWaiverShow: true,
          accountCountryCode: accountCountryCode,
          isBack: !authWithKeycloak && !!values.isCountryChooseSubmit,
          openReagreeWaiverFrom: 'idpModel',
        }
      } else if (status === STATUS.NO_COUNTRY_CODE) {
        nextState = {
          isCountryChooseShow: true,
          accountCountryCode: '',
        }
      } else if (status === STATUS.PSW_NOT_QUALFIED) {
        nextState = {
          isPasswordUpdaterShow: true,
          passwordUpdaterResult: {
            code, message,
          },
        }
      }
      this.setState({ ...this.closeModals, ...nextState })
    }

    // Show error message on layout or on popup
    handleKeycloakSubmit = (values, isShowErrorOnLayout = true) => {
      const {
        onKeycloakSubmit,
      } = this.props
      return new Promise(async resolve => {
        const result = await onKeycloakSubmit({ ...values })
        const {
          status, message, kcErrorMessage, errorCode, operation,
        } = result
        if (status === STATUS.FAILED) {
          resolve({ message: message || kcErrorMessage, errorCode })
          isShowErrorOnLayout && this.setState({
            ...this.closeModals,
            errorMsg: message,
          })
        } else {
          resolve(result)
          if ((operation === 'PHONE_SETUP_SEND' || operation === 'RESEND')
            && status === STATUS.SUCCESS) {
            // handle count down just in front end and get code from mobile
          } else {
            this.onKeycloakSubmitSuccess(values)(result)
          }
        }
      })
    }

    handleIdpSignin = ({ clickEvent, name }) => {
      // open idp window
      const { handleSocialClick } = this.props

      return handleSocialClick(
        eventData => {
          if (eventData.status === STATUS.FAILED) {
            this.setState({
              ...this.closeModals,
              errorMsg: eventData.message,
            })
          } else {
            this.onKeycloakSubmitSuccess({})(eventData)
          }
        },
      )({ clickEvent, name })
    }

    handleFacebookCreateAccount = facebookCreateAccountConfig => this.setSwitchConfig({ facebookCreateAccountConfig })

    handleFacebookBindAccount = facebookBindAccountConfig => this.setSwitchConfig({ facebookBindAccountConfig })

    handleShowCoppaEmail = (showCoppaEmailInput, pendingKey) => {
      this.setState({
        coppaEmailResult: {
          showCoppaEmailInput,
          pendingKey,
        },
      })
    }

    render() {
      const {
        Header,
        clientConfig: {
          signinOptions: signinOptionsForWidget = [{ name: 'ACTIVE', viewGroup: 'ACTIVE' }],
        },
        authWithKeycloak,
        configureTrack,
        locale,
      } = this.props
      const {
        idpValues: { email },
        facebookCreateAccountConfig, facebookBindAccountConfig,
        coppaEmailResult, passwordUpdaterResult, isBack,
        accountCountryCode, resetAgrees, clientName,
        nextTimeWindow, senderPhone, epid, channel, errorMsg,
        identityProviderAlias,
        isLinkAccountShow, isReviewProfileShow,
        isPasswordUpdaterShow, isCountryChooseShow, isGrantPermissionShow, isReagreeWaiverShow,
        isReagreeWaiverConfirmShow, isVerificationShow, isPhoneAuthenticationShow,
      } = this.state

      if (coppaEmailResult.showCoppaEmailInput) {
        return (
          <CoppaEmailInput Header={Header} {...coppaEmailResult} {...this.props} />
        )
      } if (facebookCreateAccountConfig) {
        return (
          <FacebookCreateAccount {...facebookCreateAccountConfig} {...this.props} />
        )
      } if (facebookBindAccountConfig) {
        return (
          <FacebookBindAccount
            handleReturn={() => this.setState({ facebookBindAccountConfig: null })}
            {...facebookBindAccountConfig}
            {...this.props}
          />
        )
      }

      const signinOptions = signinOptionsForWidget || []
      const activeData = find(signinOptions, { name: 'ACTIVE' })
      const isShowActiveModel = !authWithKeycloak || !!activeData // Support v4 and v5(widget)
      return (
        <DefaultComponentLayout
          nameSpace="passport-siginwith__content"
          errMsg={errorMsg}
        >
          <LayoutContent main>
            {isPasswordUpdaterShow && (
            <PasswordUpdater
              isPasswordUpdaterShow={isPasswordUpdaterShow}
              passwordUpdaterResult={passwordUpdaterResult}
              handlePasswordUpdaterModalClose={this.handlePasswordUpdaterModalClose}
              handlePasswordUpdaterSubmit={this.handlePasswordUpdaterSubmit}
              username={email}
            />
            )}
            {isCountryChooseShow && (
            <CountryChoose
              isCountryChooseShow={isCountryChooseShow}
              handleChangeCountry={this.handleChangeCountry}
              handleCountryChooseModalClose={this.handleCountryChooseModalClose}
              handleCountryChooseSubmit={this.handleCountryChooseSubmit}
            />
            )}
            {isReagreeWaiverShow && (
            <ReagreeWaiver
              isBack={isBack}
              selectedCountryCode={accountCountryCode}
              isReagreeWaiverShow={isReagreeWaiverShow}
              handleReagreeWaiverClose={this.handleReagreeWaiverClose}
              handleReagreeWaiverSubmit={this.handleReagreeWaiverNewAccountSubmit}
              handleBack={this.handleReagreeWaiverBack}
              resetAgrees={resetAgrees}
              handleReagreeWaiverCheckboxChange={this.handleReagreeWaiverCheckboxChange}
              {...pick(this.props, ['countryCodes', 'passportAPIServerHost', 'clientConfig'])}
            />
            )}
            {isReagreeWaiverConfirmShow && (
            <ReagreeWaiverConfirm
              handleCancel={this.handleReagreeWaiverConfirmCancel}
              handleReagreeWaiverConfirmClose={this.handleReagreeWaiverConfirmClose}
              isReagreeWaiverConfirmShow={isReagreeWaiverConfirmShow}
            />
            )}
            {isGrantPermissionShow && (
            <GrantPermission
              handleGrantPermissionClose={this.handleGrantPermissionClose}
              handleGrantPermissionSubmit={this.handleGrantPermissionSubmit}
              clientName={clientName}
              isGrantPermissionShow={isGrantPermissionShow}
            />
            )}
            {isVerificationShow && (
            <Verification
              onClose={this.handleVerificationClose}
              onRequestCode={this.handleVerificationRequestCode}
              onVerify={this.handleVerificationVerify}
              senderEmail={email}
              senderPhone={senderPhone}
              nextTimeWindow={nextTimeWindow}
              epid={epid}
              channel={channel}
              message={errorMsg}
              configureTrack={configureTrack}
            />
            )}
            {isPhoneAuthenticationShow && (
            <PhoneAuthentication
              locale={locale}
              onVerify={this.handleVerificationVerify}
            />
            )}
            {isReviewProfileShow
                && (
                  <ReviewProfileModal
                    handleReviewProfileModalClose={this.handleReviewProfileModalClose}
                    handleReviewProfileSubmit={this.handleReviewProfileSubmit}
                    cleanState={this.cleanState}
                    isReviewProfileShow={isReviewProfileShow}
                    {...this.props}
                    {...pick(this.state, ['emailField', 'idpValues', 'kcMessageType', 'kcErrorMessage'])}
                  />
                )}
            {isLinkAccountShow
                && (
                  <LinkAccount
                    {...this.props}
                    isLinkAccountShow={isLinkAccountShow}
                    email={email}
                    identityProviderAlias={identityProviderAlias}
                    handleLinkAccountClose={this.handleLinkAccountClose}
                    handleLinkAccountSubmit={this.handleLinkAcountSigninToLink}
                    cleanState={this.cleanState}
                    configureTrack={configureTrack}
                    {...pick(this.state, ['kcMessageType', 'kcErrorMessage'])}
                  />
                )}
            {isShowActiveModel
                && <WrappedComponent updateState={this.updateState} {...this.props} />}
            <SigninWithContent
              handleCreateAccount={this.handleFacebookCreateAccount}
              handleBindAccount={this.handleFacebookBindAccount}
              handleShowCoppaEmail={this.handleShowCoppaEmail}
              onIdpSignin={this.handleIdpSignin}
              {...this.props}
            />
          </LayoutContent>
        </DefaultComponentLayout>
      )
    }
  }
  return withI18n(withKeycloak(WrapperComponent))
}

export default injectSigninWithContent
